import React, { useState } from "react";
import ContentWrapper from "../../components/layout/ContentWrapper";
import { useCustomTranslation } from "../../helpers/translateHelpers";
import { publicCustomerUserClient } from "../../api";
import { Button, PasswordRecoveryForm } from "../../components";
import { PasswordRecoveryFormValues } from "../../components/forms/password/PasswordRecoveryForm";
import { useNavigate } from "../../helpers/navigationHelpers";

const PasswordRecoveryPage: React.FC = (): React.ReactElement => {
  const { tCommon, t } = useCustomTranslation();
  const navigate = useNavigate();

  const [recoverySent, setRecoverySent] = useState(false);

  const handleSubmit = async (values: PasswordRecoveryFormValues) =>
    await publicCustomerUserClient
      .requestPasswordReset(values)
      .then(() => setRecoverySent(true));

  return (
    <ContentWrapper small largePadding htmlTitle={t("forget_password")}>
      <h1>{tCommon("customer_portal")}</h1>
      {recoverySent ? (
        <>
          <p className="mb-6">
            {tCommon("password_recovery_sent_description")}
          </p>
          <Button
            mode="primary"
            label={tCommon("back_to_login_button")}
            onClick={() => navigate.goTo("/")}
          />
        </>
      ) : (
        <>
          <p className="mb-6">{tCommon("password_recovery_description")}</p>
          <p className="mb-2 text-sm font-bold">
            {tCommon("recovery_password")}
          </p>
          <PasswordRecoveryForm onSubmit={handleSubmit} />
        </>
      )}
    </ContentWrapper>
  );
};

export default PasswordRecoveryPage;
